import { useOpenScheduleJournalEntries } from "@components/accounting/schedules/useOpenScheduleJournalEntries";
import { ScheduleCellState } from "./views/scheduleCellState";

export function useOpenInvoiceSchedule(
    state: ScheduleCellState,
): (() => void) | undefined {
    return useOpenScheduleJournalEntries(
        state.kind === "applied"
            ? {
                  templateId: state.scheduleTemplateId,
                  scheduleApplicationId: state.scheduleApplicationId,
              }
            : null,
    );
}
